
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@/views/a-web-administracion/pc/publicaciones/controlador';
    import { Publicacion } from '@/__env/lib/Web/Publicaciones';
    import { DataTableHeader } from 'vuetify';
    import paginacion from './publicaciones-listado-paginacion.vue';
import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            paginacion
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {

        }

        public get Headers(): Array<DataTableHeader>
        {
            if ( this.Controlador.Vista.Modo == 'ventas' )
            {
                return [
                    { text: '', align: 'center', value: 'Imagen', width: '65px' },
                    { text: 'Publicaci�n', align: 'start', value: 'Col1', },
                    { text: 'Descripci�n', align: 'start', value: 'Col2' },
                    { text: 'Estado', align: 'start', value: 'Col3' },
                    { text: 'Tipo', align: 'start', value: 'Col4' },
                    { text: 'Precio', align: 'end', value: 'Col5' },
                    { text: 'Ventas', align: 'end', value: 'Ventas1' },
                    { text: 'Stock', align: 'end', value: 'Ventas2' },
                    { text: '', align: 'end', value: 'Col8' },
                ];

            }
            else if ( this.Controlador.Vista.Modo == 'envio' )
            {
                return [
                    { text: '', align: 'center', value: 'Imagen', width: '65px' },
                    { text: 'Publicaci�n', align: 'start', value: 'Col1', },
                    { text: 'Descripci�n', align: 'start', value: 'Col2' },
                    { text: 'Estado', align: 'start', value: 'Col3' },
                    { text: 'Tipo', align: 'start', value: 'Col4' },
                    { text: 'Precio', align: 'end', value: 'Col5' },
                    { text: 'Modo de env�o', align: 'center', value: 'Envio1' },
                    { text: 'Env�o gratis', align: 'center', value: 'Envio2' },
                    { text: 'Costo estimado', align: 'center', value: 'Envio3' },
                    { text: '', align: 'end', value: 'Col8' },
                ];

            } else
            {
                return [
                    { text: '', align: 'center', value: 'Imagen', width: '65px' },
                    { text: 'Publicaci�n', align: 'start', value: 'Col1', },
                    { text: 'Descripci�n', align: 'start', value: 'Col2' },
                    { text: 'Estado', align: 'start', value: 'Col3' },
                    { text: 'Tipo', align: 'start', value: 'Col4' },
                    { text: 'Precio', align: 'end', value: 'Col5' },
                    { text: 'Cuenta', align: 'end', value: 'Col6' },
                    { text: 'Fecha', align: 'end', value: 'Col7' },
                    { text: '', align: 'end', value: 'Col8' },
                ];
            }
        }

        public CargandoMenu: boolean = false;
        public Opciones = [

            {
                Tipo: 'opcion', Titulo: 'Abrir', Accion: async ( item: Publicacion ) =>
                {

                    window.open( item.URL );
                },
                Ok: ( item: Publicacion ) => true
            },
            { Tipo: 'titulo', Titulo: 'Acciones' },
            {
                Tipo: 'opcion', Titulo: 'Pausar', Accion: async ( item: Publicacion ) =>
                {

                    this.CargandoMenu = true;
                    let pdf = await item.Pausar();
                    if ( pdf )
                    {
                        Utiles.Notificaciones.Completado( `Publicaci�n pausada` );
                    } else
                    {
                        Utiles.Notificaciones.Error( `Error al modificar la publicacion` );
                    }
                    this.CargandoMenu = false;
                },
                Ok: ( item: Publicacion ) => !item.Estado.esPausada
            },

            {
                Tipo: 'opcion', Titulo: 'Activar', Accion: async ( item: Publicacion ) =>
                {

                    this.CargandoMenu = true;
                    let pdf = await item.Activar();
                    if ( pdf )
                    {
                        Utiles.Notificaciones.Completado( `Publicaci�n activada` );
                    } else
                    {
                        Utiles.Notificaciones.Error( `Error al modificar la publicacion` );
                    }
                    this.CargandoMenu = false;
                },
                Ok: ( item: Publicacion ) => !item.Estado.esActiva
            },
        ];

        Abrir( item: Publicacion )
        {
            this.Controlador.Abrir( item );
        }

        //AbrirEnOtraPesta�a( item: Publicacion )
        //{
        //    this.Controlador.AbrirEnOtraPesta�a( item );
        //}
    }
